/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 22.10.17.
 */
import update from 'immutability-helper';
import _ from "underscore";
import BaseHelper from "./BaseHelper";
import t from "../../trans";
import {InvalidActionException} from "../../Exceptions";

class SimpleHelper extends BaseHelper {

    /**
     * Apply change to the data
     * @param {string} action Action to perform to the data. One of: "insert", "update", "delete".
     * @param {Object} oldValue Old value
     * @param {Object} newValue New value
     * @param {Schema} schema Schema object for this data
     * @returns {Object} Returns changed data. If there were errors then resulted value is null and method
     * isError() returns true. NB! It is possible, that returned value is null and there are no errors! This is normal -
     * this means that assigned value should be null.
     */
    apply(action, oldValue, newValue, schema) {
        this.errors = null;
        switch (schema.getType()) {
            case "object":
                return this.applyObjectAction(action, oldValue, newValue, schema);
            case "array":
                return this.applyArrayAction(action, oldValue, newValue, schema);
            default:
                return this.applySimpleValueAction(action, oldValue, newValue, schema);
        }
    }

    /**
     * Apply change to the object data
     * @param {string} action Action to perform to the data. One of: "insert", "update", "delete".
     * @param {Object} oldValue Old value
     * @param {Object} newValue New value
     * @param {Schema} schema Schema object for this data
     * @returns {Object} Returns changed data. If there were errors then resulted value is null and method
     * isError() returns true. NB! It is possible, that returned value is null and there are no errors! This is normal -
     * this means that assigned value should be null.
     */
    applyObjectAction(action, oldValue, newValue, schema) {
        if (action !== "update") throw new InvalidActionException("Only 'update' action is possible for objects");
        return newValue;
    }

    /**
     * Apply change to the array data
     * @param {string} action Action to perform to the data. One of: "insert", "update", "delete".
     * @param {Array} oldValue Old value
     * @param {Object} newValue New value
     * @param {Schema} schema Schema object for this data
     * @returns {Array} Returns changed data. If there were errors then resulted value is null and method
     * isError() returns true. NB! It is possible, that returned value is null and there are no errors! This is normal -
     * this means that assigned value should be null.
     */
    applyArrayAction(action, oldValue, newValue, schema) {
        let spec = this.makeArrayActionUpdateSpec(action, oldValue, newValue, schema);
        if (!spec) return null;
        return update(oldValue, spec);
    }

    /**
     * Creates update spec based by action and data
     * @param {string} action Action to perform to the data. One of: "insert", "update", "delete".
     * @param {Array} oldValue Old value
     * @param {Object} newValue New value item
     * @param {Schema} schema Schema
     * @return {Object} Update spec
     */
    makeArrayActionUpdateSpec(action, oldValue, newValue, schema) {
        switch (action) {
            case "update":
                // Modify existing array item
                let index = this.findArrayItem(oldValue, newValue);
                if (index >= 0) {
                    return {[index]: {$set: newValue}};
                } else {
                    this.errors = [t("Item not found")];
                    return null;
                }
                break;
            case "insert":
                // Add new array item
                if (oldValue == null) return {$set: [newValue]};
                return {$push: [newValue]};
            case "delete":
                // Remove exsiting array item
                index = this.findArrayItem(oldValue, newValue);
                if (index >= 0) {
                    return {$splice: [[index, 1]]};
                } else {
                    this.errors = [t("Item not found")];
                    return null;
                }
                break;
        }
    }

    /**
     *
     * @param {Array} arrayValue
     * @param {Object} itemValue
     */
    findArrayItem(arrayValue, itemValue) {
        return _.findIndex(arrayValue, function (item) {
            return this.objectsAreEqual(item, itemValue);
        }.bind(this));
    }

    /**
     * Tests if two objects are equal based by their "id" and "clientId" value.
     * @param {Object} a Object a
     * @param {Object} b Object p
     * @return {boolean}
     */
    objectsAreEqual(a, b) {
        if (a.id && b.id && a.id === b.id) return true;
        return !!(a.clientId && b.clientId && a.clientId === b.clientId);
    }

    /**
     * Apply change to the simple value
     * @param {string} action Action to perform to the data. One of: "insert", "update", "delete".
     * @param {Object} oldValue Old value
     * @param {Object} newValue New value
     * @param {Schema} schema Schema object for this data
     * @returns {Object} Returns changed data. If there were errors then resulted value is null and method
     * isError() returns true. NB! It is possible, that returned value is null and there are no errors! This is normal -
     * this means that assigned value should be null.
     */
    applySimpleValueAction(action, oldValue, newValue, schema) {
        if (action !== "update") throw new InvalidActionException("Only 'update' action is possible for simple values");
        if (_.isObject(newValue)) {
            this.errors = [t("Invalid value")];
            return null;
        }
        return newValue;
    }
}

export default SimpleHelper;
